import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const saveClientCopVersion = api(async function saveClientCopVersion({ clientId, codeOfPracticeId }) {
    return mutate(
        gql`
            mutation SaveClientCopVersion($clientId: ID!, $codeOfPracticeId: ID) {
                saveClientCopVersion(clientId: $clientId, codeOfPracticeId: $codeOfPracticeId)
            }
        `,
        { clientId, codeOfPracticeId },
        { returns: "saveClientCopVersion" }
    )
})
